import React from 'react'
import classNames from 'classnames'

import { useRightRailOverlay } from '../context/RightRailOverlayContext'
import LabsHistoryWidget from './labs/LabsHistoryWidget'
import PrescriptionsSummaryWidget from './prescriptions/PrescriptionsSummaryWidget'
import ProblemsSummaryWidget from './problems/ProblemsSummaryWidget'
import RhapVitalsWidget from './vitals/RhapVitalsWidget'

import styles from './PatientMedicalSummaryRail.module.scss'

interface PatientMedicalSummaryRailContentProps {
  clientId: string
  patientId: string
}

export const PatientMedicalSummaryRailContent = ({
  clientId,
  patientId,
}: PatientMedicalSummaryRailContentProps) => {
  const { isOverlayOpen, overlayContent } = useRightRailOverlay()

  return (
    <div
      className={classNames(styles.railContent, {
        [styles.overlayOpen]: isOverlayOpen,
      })}
    >
      {isOverlayOpen && (
        <div className={styles.overlayContainer}>{overlayContent}</div>
      )}
      <RhapVitalsWidget patientId={patientId} />
      <ProblemsSummaryWidget clientId={clientId} patientId={patientId} />
      <PrescriptionsSummaryWidget clientId={clientId} patientId={patientId} />
      <LabsHistoryWidget clientId={clientId} patientId={patientId} />
    </div>
  )
}
